import React, { useEffect, useState } from "react";
import { Button, Card, Row, Col, Flex } from "antd";
import { CloseOutlined } from "@ant-design/icons";
import "./InstallAppBanner.scss";
import { useLocation } from "react-router";
import { ReactComponent as PlayStoreLogo } from "../../assets/googleplaystore.svg";

export default function InstallAppBanner() {
  const [visible, setVisible] = useState(true);
  const location = useLocation();

  // Reopen when route/screen changes
  useEffect(() => {
    setVisible(true);
  }, [location.pathname]);

  // Reopen when user switches tabs
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (!document.hidden) {
        setVisible(true);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () =>
      document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);
  if (!visible || !/Android/i.test(navigator.userAgent)) return null;

  return (
    <Card variant={"outlined"} className="install-banner">
      <CloseOutlined className="close-btn" onClick={() => setVisible(false)} />
      <Flex vertical align="middle" justify="space-between" gap={5}>
        <div className="install-text">
          <strong>Get our Mobile App</strong>
          <p>Install the app for a better & faster experience.</p>
        </div>
        <Button
          type="primary"
          size="large"
          icon={<PlayStoreLogo style={{ width: 30}} />}
          href="https://play.google.com/store/apps/details?id=com.itcinfotech.eAuction"
        >
          Install
        </Button>
      </Flex>
    </Card>
  );
}
